import React from 'react';
import LoaderItemsDocuments from '../Loader';

import { Container } from './styles';

function FakeItems({ isMobile }) {
  return (
    <Container>
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
      <LoaderItemsDocuments isMobile={isMobile} />
    </Container>
  );
}

export default FakeItems;
